// test1610
(1610 && 0);
